const messageTemplate = (
  authData,
  date,
  subject,
  requestType,
  sendTo,
  sendCc,
  sendBcc,
  prevContent,
  timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
) => {
  // Converted time
  const convertTimeToTimezone = (time) => {
    return new Date(time)?.toLocaleString("en-US", {
      timeZone: timezone || "UTC",
      hour12: false, // 24-hour format
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  };

  return `
            <div>
            <p><br></p><p>Regards,</p><p><span style="color: rgb(255, 153, 0);">${
              authData?.fullName
            }</span></p>
        <p><span style=" color: gray;">-----------------------------------------------------------------------------------------------------------------</span></p>
              <p>
  <span style="font-size: 5px; color: gray;">Previous Message - ${convertTimeToTimezone(
    date
  )}</span>
</p>
              <p> <span style="font-size: 5px; color: gray;">Subject: ${subject} - ${requestType}</span></p>
              <p ><span style="font-size: 5px; color: gray;">TO: ${sendTo}</span></p>
              <p> <span style="font-size: 5px; color: gray;">CC: ${sendCc}</span></p>   
              <p> <span style="font-size: 5px; color: gray;">BCC: ${sendBcc}</span></p>
            <p> <span style="font-size: 5px; color: gray;">${prevContent}</span></p>
            </div>
          `;
};

export default messageTemplate;
